import { Stock, StockWithHistory, PriceHistoryPoint } from '../types';

export const MOCK_STOCKS: Stock[] = [
  { ticker: 'AAPL', name: 'Apple Inc.', currentPrice: 175.43, change: 2.34, changePercent: 1.35 },
  { ticker: 'GOOGL', name: 'Alphabet Inc.', currentPrice: 2847.92, change: -15.67, changePercent: -0.55 },
  { ticker: 'MSFT', name: 'Microsoft Corporation', currentPrice: 378.85, change: 5.23, changePercent: 1.40 },
  { ticker: 'AMZN', name: 'Amazon.com Inc.', currentPrice: 3285.04, change: -8.92, changePercent: -0.27 },
  { ticker: 'TSLA', name: 'Tesla Inc.', currentPrice: 248.50, change: 12.45, changePercent: 5.28 },
  { ticker: 'META', name: 'Meta Platforms Inc.', currentPrice: 342.18, change: 3.87, changePercent: 1.14 },
  { ticker: 'NVDA', name: 'NVIDIA Corporation', currentPrice: 891.34, change: -22.15, changePercent: -2.42 },
  { ticker: 'NFLX', name: 'Netflix Inc.', currentPrice: 485.67, change: 7.89, changePercent: 1.65 },
  { ticker: 'AMD', name: 'Advanced Micro Devices', currentPrice: 156.78, change: -3.45, changePercent: -2.15 },
  { ticker: 'CRM', name: 'Salesforce Inc.', currentPrice: 234.56, change: 4.12, changePercent: 1.79 }
];

// Generate mock historical data for each stock
const generatePriceHistory = (ticker: string, currentPrice: number, days: number = 365): PriceHistoryPoint[] => {
  const history: PriceHistoryPoint[] = [];
  const today = new Date();
  
  // Start with a base price and generate realistic price movements
  let price = currentPrice * 0.7; // Start 30% lower
  
  for (let i = days; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    
    // Add some randomness to price movement
    const changePercent = (Math.random() - 0.5) * 0.1; // ±5% daily change
    price = price * (1 + changePercent);
    
    // Ensure price doesn't go negative
    price = Math.max(price, 1);
    
    history.push({
      date,
      price: Math.round(price * 100) / 100
    });
  }
  
  return history;
};

export const MOCK_STOCKS_WITH_HISTORY: StockWithHistory[] = MOCK_STOCKS.map(stock => ({
  ...stock,
  history: generatePriceHistory(stock.ticker, stock.currentPrice)
}));

// Function to simulate real-time price updates
export const simulatePriceUpdate = (stock: Stock): Stock => {
  const volatility = 0.02; // 2% max change
  const changePercent = (Math.random() - 0.5) * volatility;
  const newPrice = stock.currentPrice * (1 + changePercent);
  const change = newPrice - stock.currentPrice;
  
  return {
    ...stock,
    currentPrice: Math.round(newPrice * 100) / 100,
    change: Math.round(change * 100) / 100,
    changePercent: Math.round((change / stock.currentPrice) * 10000) / 100
  };
};
